/**
 * DateSeparator — Horizontal line with centered date pill between message groups
 */

import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDateSeparator } from '../utils/dateUtils';

interface DateSeparatorProps {
  date: Date;
}

export const DateSeparator = memo(function DateSeparator({ date }: DateSeparatorProps) {
  const { t, i18n } = useTranslation();
  const label = formatDateSeparator(date, i18n.language, t);

  return (
    <div className="relative z-10 my-3 flex justify-center px-4">
      <span className="rounded-full bg-white px-4 py-1 text-xs font-semibold text-slate-500 shadow-sm">
        {label}
      </span>
    </div>
  );
});
